// Perfis de gestão institucional — mesma lista de usePlayfulNav.js:6
// (SIDEBAR_PROFILES). Repetida aqui para não acoplar a menu-admin.jsx;
// perfil novo lá precisa entrar aqui também.
const MANAGEMENT_PROFILES = ['Administrador', '4 secretariado', 'Tutor', 'Designer Institucional'];

// "Professor puro": leciona e não acumula papel de gestão. Só ele perde
// destinos institucionais — quem é Professor + Administrador continua vendo
// tudo. Mesma origem de perfis do usePlayfulNav.
export function isTeacherOnly(session) {
  const profiles = session?.user?.profileNames || session?.user?.['profile-names'] || [];
  return profiles.includes('Professor') && !profiles.some(profile => MANAGEMENT_PROFILES.includes(profile));
}

// Mesma regra do item "Exercícios" em menu-admin.jsx — fonte única, usada por
// ele e pelo card "Exercícios" da Home do professor (teacher-shortcuts.jsx),
// pra não divergirem se alguém editar só um dos dois.
export function canViewExercicios(session, abilities, checkPermission) {
  return (
    !isTeacherOnly(session) &&
    (checkPermission(session, 'Visualizar lista de provas', 'Provas e simulados') ||
      checkPermission(session, 'Visualizar banco de questões', 'Questões e exercícios') ||
      checkPermission(session, 'Visualizar exercícios', 'Questões e exercícios') ||
      checkPermission(session, 'Visualizar resultados', 'Provas e simulados')) &&
    Boolean(abilities?.avaliacoes)
  );
}
